import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import i18n from './locales'
import './mixins'
import jquery from 'jquery'

Vue.config.productionTip = false

new Vue({
  i18n,
  router,
  store,
  vuetify,
  jquery,
  render: h => h(App)
}).$mount('#app')
